import React, { useState, useCallback, useEffect } from 'react';
import { Check } from 'lucide-react';
import Calendar from './CalendarFrame';
import moment from 'moment';
import ApiService from "../../api/ApiService";
import { AiOutlineCalendar } from "react-icons/ai";
import { filter } from 'lodash';
import notification from "../../helpers/notification";
import { useNavigate } from "react-router-dom";

const MAX_PEOPLE_PER_DATE = 4;

const INITIAL_FORM_DATA = {
  fullName: '',
  age: '',
  mobileNo: '',
  emailId: '',
  profession: '',
  eduQualif: '',
  orgName: '',
  jobTitle: '',
  address: '',
  numberOfPeople: '1'
};

// Utility functions
const formatDateString = (date) => moment(date).format('YYYY-MM-DD');

const formatDisplayDate = (date) => moment(date).format('dddd, MMMM Do YYYY');

const UpdateForm = ({ id, phone, selectedDate, onSubmit, onClose, getBookingsCount, currentDate, handleDateSelect, handleMonthChange, isDateAvailable }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [show, setShow] = useState(false);

  const [bookingsData, setBookingsDataFromBackend] = useState([]);

  console.log("getBookingsCount(formatDateString(selectedDate))", getBookingsCount(formatDateString(selectedDate)))
  const availableSlots = selectedDate
    ? MAX_PEOPLE_PER_DATE - getBookingsCount(formatDateString(selectedDate))
    : 0;
  const isToday = moment(selectedDate).isSame(moment(), "day");
  const finalSlots = isToday && moment().hour() >= 10 ? 0 : availableSlots;

  const fetchBookings = async () => {
    try {
      const response = await ApiService.getAllAnnadaanSevaBookingsdb(phone);


      const allBookings = Object.values(response.data).flat(); // flatten all date arrays into one
      const filtered = allBookings.filter(booking => booking.id === id);

      setBookingsDataFromBackend(filtered); // or handle as needed
    } catch (error) {
      console.log("error", error);
    }
  }



  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }))
  }, []);

  const handleSubmit = async () => {
    try {

      if (!finalSlots > 0) {
        return notification('warning', 'please select resheduled date!')
      }

      const sendData = {
        date: moment(selectedDate).format("YYYY-MM-DD"),
        participants: formData.numberOfPeople,
        id: id
      };

      const response = await ApiService.reSheduledAnnadaanSevaBookings(sendData);

      if (response?.status === 200 || response?.message) {
        notification("success", response.message || "Resheduled successfully!");
        fetchBookings();
        navigate("/annadaanseva")
      } else {
        notification("error", "Failed to cancel booking.");
      }
    } catch (error) {
      notification("error", "Something went wrong!");
      console.error("Error in handelCancel:", error);
    }
  };





  const handleCalender = () => {
    try {
      setShow(true)
    } catch (error) {
      console.log(error)
    }

  }


  const handleCalenderClose = () => {
    try {
      setShow(false)
    } catch (error) {
      console.log(error)
    }

  }

  useEffect(() => {
    fetchBookings();
  }, [id]);

  return (
    <div className="container py-3">
      <form className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Full Name *</label>
          <input type="text" name="fullName" className="form-control" disabled value={bookingsData[0]?.name} onChange={handleInputChange} required />
        </div>
        {/* <div className="col-md-6">
          <label className="form-label">Age</label>
          <input type="number" name="age" className="form-control" disabled value={bookingsData[0]?.age} onChange={handleInputChange} min="1" max="99" />
        </div> */}

        <div className="col-md-6">
          <label className="form-label">Mobile No *</label>
          <input type="tel" name="mobileNo" className="form-control" disabled value={bookingsData[0]?.phone} onChange={handleInputChange} required />
        </div>
        <div className="col-md-6">
          <label className="form-label">Email ID</label>
          <input type="email" name="emailId" className="form-control" disabled value={bookingsData[0]?.email} onChange={handleInputChange} />
        </div>

        <div className="col-md-6">
          <label className="form-label">Profession *</label>
          <input type="text" name="profession" className="form-control" disabled value={bookingsData[0]?.profession} onChange={handleInputChange} required />
        </div>
        <div className="col-md-6">
          <label className="form-label">Education Qualification *</label>
          <input type="text" name="eduQualif" className="form-control" disabled value={bookingsData[0]?.education} onChange={handleInputChange} required />
        </div>

        <div className="col-md-6">
          <label className="form-label">Organisation Name *</label>
          <input type="text" name="orgName" className="form-control" disabled value={bookingsData[0]?.organization} onChange={handleInputChange} required />
        </div>
        {/* <div className="col-md-6">
          <label className="form-label">Job Title *</label>
          <input type="text" name="jobTitle" className="form-control" disabled value={bookingsData[0]?.jobTitle} onChange={handleInputChange} required />
        </div> */}

        <div className="col-12">
          <label className="form-label">Complete Address *</label>
          <textarea name="address" className="form-control" rows="3" disabled value={bookingsData[0]?.address} onChange={handleInputChange} required />
        </div>

        <div className="col-md-6">
          <label className="form-label d-block">&nbsp;</label>
          <button
            type="button"
            className={`btn w-100 ${show ? 'btn-danger' : 'btn-outline-secondary'}`}
            onClick={() => setShow(!show)}
          >
            {show ? 'Close Calendar' : (
              <span className="d-flex justify-content-between align-items-center">
                <span>Select Date</span>
                <AiOutlineCalendar size={20} />
              </span>
            )}
          </button>
        </div>

        {show && (
          <>
            <div className="col-12">
              <div className="border p-3 bg-light rounded">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <strong>{selectedDate && formatDisplayDate(selectedDate)}</strong><br />
                    <small>{finalSlots} slots available</small>
                  </div>
                  <div className={`fw-bold ${finalSlots > 0 ? 'text-success' : 'text-danger'}`}>
                    {finalSlots > 0 ? <><Check size={16} /> Available</> : 'Not Available'}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12">
              <Calendar
                currentDate={currentDate}
                selectedDate={selectedDate}
                onDateSelect={handleDateSelect}
                onMonthChange={handleMonthChange}
                getBookingsCount={getBookingsCount}
                isDateAvailable={isDateAvailable}
              />
            </div>
          </>
        )}

        <div className="col-md-6">
          <label className="form-label">Number of Participants (including you) *</label>
          <select
            name="numberOfPeople"
            value={formData.numberOfPeople}
            onChange={handleInputChange}
            className="form-select"
          >
            {Array.from({ length: 4 }, (_, i) => i + 1).map((num) => (
              <option key={num} value={num}>{num}</option>
            ))}
          </select>
        </div>

        <div className="col-12">
          <button type="button" onClick={handleSubmit} className="btn btn-warning w-100 fw-bold">
            Confirm Booking
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateForm;
